/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Tabs_DeliveryInputs */

const he_account_tabs_delivery = /** @type {(inputs: Account_Tabs_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוצי שליחה`)
};

const en_account_tabs_delivery = /** @type {(inputs: Account_Tabs_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery`)
};

/**
* | output |
* | --- |
* | "Delivery" |
*
* @param {Account_Tabs_DeliveryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_tabs_delivery = /** @type {((inputs?: Account_Tabs_DeliveryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Tabs_DeliveryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_tabs_delivery(inputs)
	return en_account_tabs_delivery(inputs)
});